import OLMapProperty from 'ol/MapProperty';

export const MapProperty = Object.assign({
  ID: 'id',
  CONTEXT_URL: 'contextUrl',
  CONTEXT_PUSH_ENABLED: 'contextPushEnabled',
  CONTEXT_MENU_ENABLED: 'contextMenuEnabled',
  SELECTED_LAYER: 'selectedLayer',
  PRIMARY_INTERACTION: 'primaryInteraction',
  DEFAULT_STYLES: 'defaultStyles',
  DRAW_STYLES: 'drawStyles',
  HIGHLIGHT_STYLES: 'highlightStyles',
  DEFAULT_STYLES_SERIALIZED: 'defaultStylesSerialized',
  DRAW_STYLES_SERIALIZED: 'drawStylesSerialized',
  HIGHLIGHT_STYLES_SERIALIZED: 'highlightStylesSerialized',
  TAGS: 'tags',
  LEGEND_VISIBLE: 'legendVisible',
  SETTINGS_VISIBLE: 'settingsVisible',
  TOOLBAR_VISIBLE: 'toolbarVisible',
  CONTROLS_VISIBLE: 'controlsVisible',
  SKETCH_EDITOR: 'sketchEditor',
  SKETCH_LAYER: 'sketchLayer',
  POLYGON_CONDITION_LAYER: 'polygonConditionLayer',
  EDITING_LAYER: 'editingLayer',
  OVERVIEW_MAP_DYNAMIC_EXTENT: 'overviewMapDynamicExtent',
  OVERVIEW_MAP_DYNAMIC_ASPECT_RATIO: 'overviewMapDynamicAspectRatio',
  HIDPI: 'hidpi',
  WORKBOOK_ID_AND_HASH: 'workbookIdAndHash',
  IS_WORKBOOK_MAP: 'isWorkbookMap',
  LAYER_ACTIONS_PROVIDER: 'layerActionsProvider',
  GAZETTEER_SUGGESTION_PROVIDERS: 'gazetteerSuggestionProvider',
  LAST_SELECTION_CLICK_PX: 'lastSelectionClickPx'
}, OLMapProperty);
